<template>
  <div class="CustomerList">
    <div style="height: 13.2rem;
    background: #fff;">
      <img src="http://yd.top917.cn/date/images/kefu1.jpg">
      <a href="tel:4006-688-252#mp.weixin.qq.com "><div style="height: 1rem;  width: 4rem; position: absolute;top: 2.25rem; left: 1.8rem;"  @click="tel()"></div></a>
      <img src="http://yd.top917.cn/date/images/kefu2.jpg">
      <img src="http://yd.top917.cn/date/images/saoma.jpg" style=" position: absolute;width: 2.5rem; top: 5.3rem; left: 2.5rem;">
      <img src="http://yd.top917.cn/date/images/kefu3.jpg">
      <img src="http://yd.top917.cn/date/images/kefu4.jpg">
    </div>
    <div
      class="item acea-row row-between-wrapper"
      v-for="item in list"
      :key="item.id"
      @click="$router.push('/customer/chat/' + item.uid)"
    >
      <div class="pictrue"><img :src="item.avatar" /></div>
      <div class="text line1">{{ item.nickname }}</div>
    </div>
  </div>
</template>
<script>
import { serviceList } from "@api/user";

export default {
  name: "CustomerList",
  data() {
    return {
      list: []
    };
  },
  methods: {
    getList() {
      serviceList().then(res => {
        this.list = res.data;
      });
    }
    
  },
  mounted() {
    this.getList();
  }
};
</script>
<style scoped>
.CustomerList {
  margin-top: 0.13rem;
}
.CustomerList .item {
  height: 1.38rem;
  border-bottom: 1px solid #eee;
  padding: 0 0.24rem;
  background-color: #fff;
}
.CustomerList .item .pictrue {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 50%;
  border: 0.03rem solid #fff;
  box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -webkit-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -moz-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
}
.CustomerList .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.CustomerList .item .text {
  width: 5.82rem;
  font-size: 0.32rem;
  color: #000;
}

img{
  width: 100%;
  display: block;
}
body{
  background-color: #fff;
}
</style>
